export default "__VITE_ASSET__5590ba2d__"